(function(){
  var el=document.getElementById('rk-data');
  if(!el)return;
  var D;try{D=JSON.parse(el.textContent);}catch(e){return;}
  var COLORS=(D.colores||[]).filter(function(c){return c.n;});
  COLORS.forEach(function(c,i){c.k='c'+i;c.p=c.fu?D.recargoFusion:0;});
  var P=D.precios,FREE=D.envioGratis,FU=D.recargoFusion;
  var list=[],root=document.documentElement;
  function mix(hex,amt){hex=(hex||'#999999').replace('#','');var n=parseInt(hex,16),r=n>>16,g=n>>8&255,b=n&255;r=Math.round(r+(255-r)*amt);g=Math.round(g+(255-g)*amt);b=Math.round(b+(255-b)*amt);return 'rgb('+r+','+g+','+b+')';}
  function unit(n){return n>=5?P[3]:n>=3?P[2]:n===2?P[1]:P[0];}
  function fmt(x){return '$'+Math.round(x).toLocaleString('es-CO');}
  function find(k){for(var i=0;i<COLORS.length;i++)if(COLORS[i].k===k)return COLORS[i];}
  function total(){var n=list.length,t=n?unit(n)*n:0;list.forEach(function(k){t+=find(k).p;});return t;}
  function full(){var t=0;list.forEach(function(k){t+=P[0]+find(k).p;});return t;}
  function plural(n){return n===1?'1 Rooki':n+' Rookis';}

  var word=document.getElementById('word'),dino=document.getElementById('dino'),stage=document.querySelector('.stage');
  var WMAX=0;
  function measure(){if(!stage)return;var m=document.createElement('span');m.className='word';m.style.cssText='position:absolute;visibility:hidden;font-size:100px;white-space:nowrap';stage.appendChild(m);WMAX=0;COLORS.forEach(function(c){m.textContent=c.w||c.n;WMAX=Math.max(WMAX,m.getBoundingClientRect().width);});m.remove();}
  function fit(){if(!stage||!word)return;var W=stage.clientWidth;if(!WMAX)measure();if(WMAX)word.style.fontSize=Math.min(W*.98/WMAX*100,150).toFixed(1)+'px';if(dino)dino.style.width=Math.min(W*.94,540)+'px';}
  if(document.fonts&&document.fonts.ready)document.fonts.ready.then(function(){WMAX=0;fit();});
  function show(c){
    if(!c)return;
    root.style.setProperty('--c',c.c);root.style.setProperty('--t1',mix(c.c,.84));root.style.setProperty('--t2',mix(c.c,.5));
    if(word){word.textContent=c.w||c.n;fit();}
    if(dino&&c.img){dino.classList.add('out');var im=new Image();im.onload=function(){dino.removeAttribute('srcset');dino.src=im.src;dino.classList.remove('out');};im.src=c.img;}
  }
  window.addEventListener('resize',fit);
  var first=COLORS[0];
  if(first){root.style.setProperty('--c',first.c);root.style.setProperty('--t1',mix(first.c,.84));root.style.setProperty('--t2',mix(first.c,.5));if(word){word.textContent=first.w||first.n;fit();}}
  function warm(c){if(c&&c.img&&!c._w){c._w=1;var i=new Image();i.decoding='async';i.src=c.img;}}
  var auto=null,ai=0,seq=COLORS.slice(0,8);
  if(seq.length>1&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches){var startAuto=function(){if(list.length)return;warm(seq[1]);auto=setInterval(function(){ai=(ai+1)%seq.length;show(seq[ai]);warm(seq[(ai+1)%seq.length]);},2600);};if(document.readyState==='complete')setTimeout(startAuto,1500);else window.addEventListener('load',function(){setTimeout(startAuto,1500);});}
  function stopAuto(){if(auto){clearInterval(auto);auto=null;}}

  var grid=document.getElementById('grid'),gridF=document.getElementById('gridF'),cards=[];
  COLORS.forEach(function(c){
    var b=document.createElement('button');b.type='button';b.className='sp';b.dataset.k=c.k;
    b.setAttribute('aria-label','Agregar Rooki '+c.n+(c.p?', suma '+fmt(c.p):'')+(c.bd?', '+c.bd:''));
    var card=document.createElement('span');card.className='card';card.style.background=mix(c.c,.84);
    if(c.th||c.img){var im=document.createElement('img');im.src=c.th||c.img;im.alt='';im.loading='lazy';im.decoding='async';im.width=400;im.height=252;card.appendChild(im);}
    b.appendChild(card);
    if(c.bd){var bd=document.createElement('span');bd.className='bd'+(c.ltd?' ltd':'');bd.textContent=c.bd;b.appendChild(bd);}
    var q=document.createElement('span');q.className='q';q.hidden=true;b.appendChild(q);
    var nm=document.createElement('span');nm.className='nm';nm.textContent=c.n;
    if(c.fu){var ex=document.createElement('span');ex.className='ex';ex.textContent='Fusión, +'+fmt(c.p);nm.appendChild(ex);}
    b.appendChild(nm);
    if(!c.id||!c.ok){b.disabled=true;b.style.opacity='.45';b.setAttribute('aria-label',c.n+': agotado');}
    b.addEventListener('click',function(){stopAuto();list.push(c.k);show(c);render();});
    b.addEventListener('pointerenter',function(){warm(c);},{passive:true});
    var target=c.fu?gridF:grid;if(target)target.appendChild(b);cards.push(b);
  });

  function $(id){return document.getElementById(id);}
  var qs=new URLSearchParams(location.search),club=qs.get('club')==='1';
  try{if(club)sessionStorage.setItem('rk-club','1');club=club||sessionStorage.getItem('rk-club')==='1';}catch(e){}
  var pre=(qs.get('color')||'').trim().toLowerCase();
  if(pre){var pc=COLORS.filter(function(c){return c.n.toLowerCase()===pre&&c.id&&c.ok;})[0];if(pc){list.push(pc.k);show(pc);}}
  if(club){var sm=$('comprar');if(sm){var cn=document.createElement('p');cn.style.cssText='margin:0;background:var(--ink);color:#fff;border-radius:12px;padding:11px 14px;font-size:14.5px;line-height:1.35';cn.innerHTML='<b>Eres del Rookis Club.</b> Tu pedido lleva un regalo sorpresa de cortesía.';sm.insertBefore(cn,sm.firstChild);}}
  var refocus=null;
  function render(){
    var n=list.length,t=total(),f=full();
    cards.forEach(function(b){var q=list.filter(function(k){return k===b.dataset.k}).length,s=b.querySelector('.q');s.hidden=!q;s.textContent=q;b.classList.toggle('on',q>0);});
    $('count').textContent=n?plural(n):'Aún no eliges';
    var cl=$('clear');if(cl)cl.hidden=!n;
    $('total').textContent=fmt(t);
    $('save').textContent=f>t?'Ahorras '+fmt(f-t):'';
    var nx=$('next');
    if(!n)nx.textContent='Desde 5 Rookis, cada uno te sale en '+fmt(P[3])+'.';
    else if(n<5){var g=n<2?2:n<3?3:5;nx.textContent='Agrega '+(g-n)+' más y cada Rooki te sale en '+fmt(unit(g))+'.';}
    else nx.textContent='Tienes el mejor precio: '+fmt(unit(n))+' por Rooki.';
    var tier=n>=5?5:n>=3?3:n;document.querySelectorAll('.tiers tr').forEach(function(r){r.classList.toggle('cur',+r.dataset.t===tier);});
    document.querySelectorAll('[data-buy]').forEach(function(b){b.disabled=!n;});
    $('ctaTot').textContent=n?fmt(t):'';
    $('stCount').textContent=n?plural(n):'Desde '+fmt(P[3])+' c/u';
    $('stTot').textContent=n?fmt(t):'Envío gratis desde '+fmt(FREE);
    var bk=$('brk'),fu=list.filter(function(k){return find(k).p>0;}).length;bk.hidden=!n;bk.textContent='';
    if(n){
      var u=unit(n),ord=[];list.forEach(function(k){if(ord.indexOf(k)<0)ord.push(k);});
      ord.forEach(function(k){
        var c=find(k),q=list.filter(function(x){return x===k;}).length;
        var d=document.createElement('div');d.className='li';
        var a=document.createElement('span');a.className='ln';a.textContent=c.n;
        var s=document.createElement('span');s.className='stp';
        var mn=document.createElement('button');mn.type='button';mn.dataset.k=k;mn.dataset.d='-1';mn.textContent='−';mn.setAttribute('aria-label','Quitar un Rooki '+c.n);
        var qn=document.createElement('span');qn.className='qn';qn.textContent=q;qn.setAttribute('aria-label',q+' de '+c.n);
        var pl=document.createElement('button');pl.type='button';pl.dataset.k=k;pl.dataset.d='1';pl.textContent='+';pl.setAttribute('aria-label','Agregar un Rooki '+c.n);
        s.appendChild(mn);s.appendChild(qn);s.appendChild(pl);
        var lt=document.createElement('span');lt.className='lt';lt.textContent=fmt((u+c.p)*q);
        d.appendChild(a);d.appendChild(s);d.appendChild(lt);bk.appendChild(d);
      });
      var un=document.createElement('p');un.className='un';un.textContent='Cada Rooki a '+fmt(u)+(fu?' · Fusión +'+fmt(FU)+' c/u':'');bk.appendChild(un);
    }
    if(refocus){var fb=bk.querySelector('button[data-k="'+refocus.k+'"][data-d="'+refocus.d+'"]');if(fb)fb.focus();else if(cl&&!cl.hidden)cl.focus();refocus=null;}
    var sh=$('ship');
    if(n&&t>FREE){sh.textContent='Tu envío es gratis.';sh.classList.add('free');}
    else{sh.textContent='Envío gratis en compras superiores a '+fmt(FREE)+'.';sh.classList.remove('free');}
  }
  $('brk').addEventListener('click',function(e){
    var b=e.target.closest('button[data-k]');if(!b)return;
    var k=b.dataset.k,d=+b.dataset.d;
    if(d>0){list.push(k);stopAuto();show(find(k));}
    else{var i=list.lastIndexOf(k);if(i>-1)list.splice(i,1);}
    refocus={k:k,d:b.dataset.d};render();
  });
  var clr=$('clear');if(clr)clr.addEventListener('click',function(){list=[];render();var c=$('coleccion');if(c)c.scrollIntoView({behavior:'smooth',block:'start'});});

  var busy=false;
  function buy(){
    if(!list.length){$('coleccion').scrollIntoView({behavior:'smooth'});return;}
    if(busy)return;busy=true;
    var err=$('err');err.hidden=true;
    var qty={};list.forEach(function(k){var c=find(k);qty[c.id]=(qty[c.id]||0)+1;});
    var items=Object.keys(qty).map(function(id){return {id:+id,quantity:qty[id]};});
    var btns=document.querySelectorAll('[data-buy],[data-sticky]');btns.forEach(function(b){b.disabled=true;});
    fetch('/cart/clear.js',{method:'POST',headers:{'Content-Type':'application/json'}})
      .then(function(){return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})});})
      .then(function(r){if(!r.ok)return r.json().then(function(j){throw new Error(j.description||j.message||'No se pudo agregar');});return r.json();})
      .then(function(){return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{'Rookis Club':club?'Sí: incluir regalo sorpresa':''}})});})
      .then(function(){window.location.href=D.checkout?'/checkout':'/cart';})
      .catch(function(e){busy=false;btns.forEach(function(b){b.disabled=false;});err.textContent='No pudimos abrir el pago: '+e.message+'. Intenta de nuevo o escríbenos por WhatsApp.';err.hidden=false;});
  }
  document.querySelectorAll('[data-buy],[data-sticky]').forEach(function(b){b.addEventListener('click',buy);});

  var lb=$('lb');
  if(lb){
    var lbi=$('lbi'),lbc=$('lbc'),cur=[],ci=0,tit='',last=null;
    function lbShow(){lbi.src=cur[ci];lbi.alt='Foto '+(ci+1)+': '+tit;lbc.textContent=cur.length>1?(ci+1)+' de '+cur.length:'';$('lbp').hidden=$('lbn').hidden=cur.length<2;}
    function lbOpen(f,i,t){last=document.activeElement;cur=f;ci=i;tit=t;lbShow();lb.hidden=false;$('lbx').focus();}
    function lbClose(){lb.hidden=true;if(last)last.focus();}
    document.querySelectorAll('.rv').forEach(function(a){
      var f=(a.dataset.fotos||'').split('|').filter(Boolean);
      a.querySelectorAll('[data-i]').forEach(function(btn){btn.addEventListener('click',function(){lbOpen(f,+btn.dataset.i,a.dataset.titulo);});});
    });
    $('lbx').addEventListener('click',lbClose);
    $('lbp').addEventListener('click',function(){ci=(ci-1+cur.length)%cur.length;lbShow();});
    $('lbn').addEventListener('click',function(){ci=(ci+1)%cur.length;lbShow();});
    lb.addEventListener('click',function(e){if(e.target===lb||e.target.classList.contains('pic'))lbClose();});
    document.addEventListener('keydown',function(e){if(lb.hidden)return;if(e.key==='Escape')lbClose();if(e.key==='ArrowRight')$('lbn').click();if(e.key==='ArrowLeft')$('lbp').click();});
  }

  var st=$('sticky'),vis={};
  if(st&&'IntersectionObserver' in window){var io=new IntersectionObserver(function(es){es.forEach(function(e){vis[e.target.dataset.io]=e.isIntersecting;});st.classList.toggle('show',!vis.h&&!vis.s&&scrollY>300);});
    var h=document.querySelector('.copy');if(h){h.dataset.io='h';io.observe(h);}var s=$('comprar');if(s){s.dataset.io='s';io.observe(s);}}
  else if(st)st.classList.add('show');
  render();
})();
